// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__Vm3ob","containerItemsCenter":"Skeleton_containerItemsCenter__38lrf"};